import React, {useState} from 'react';

const Policy = () => {
    const [activeTab, setActiveTab] = useState('terms');
    return (
        <main className="flex-grow container mx-auto px-4 py-16">
            <div className="max-w-4xl mx-auto" x-data="{ activeTab: 'terms' }">
                <h1 className="sm:text-3xl text-2xl font-bold mb-6">약관 및 정책</h1>
                <div className="flex">
                    <button onClick={event => {
                        setActiveTab('terms');
                    }}
                            className={activeTab === 'terms' ? 'bg-teal-500 text-white font-bold px-5 py-3  sm:mb-0 bg-[14b8a6] whitespace-nowrap' : ' text-gray-400 font-bold px-5 py-3  sm:mb-0 whitespace-nowrap'}>이용약관
                    </button>
                    <button onClick={event => {
                        setActiveTab('policy');
                    }}
                            className={activeTab === 'policy' ? 'bg-teal-500 text-white font-bold px-5 py-3  sm:mb-0 bg-[14b8a6] whitespace-nowrap' : ' text-gray-400 font-bold px-5 py-3  sm:mb-0 whitespace-nowrap'}>운영정책
                    </button>
                    <button onClick={event => {
                        setActiveTab('privacy');
                    }}
                            className={activeTab === 'privacy' ? 'bg-teal-500 text-white font-bold px-5 py-3  sm:mb-0 bg-[14b8a6] whitespace-nowrap' : ' text-gray-400 font-bold px-5 py-3  sm:mb-0 whitespace-nowrap'}>개인정보
                        처리방침
                    </button>
                </div>
                <div className="border-b-2 border-teal-500 mb-10"></div>
                <div className="bg-white break-keep tracking-[-0.28px] font-normal text-sm mb-[200px]">
                    {
                        activeTab === 'terms' && <div>
                            <br/><h2 className="text-sm font-bold">일사 Sales Partnership 프로그램 이용약관(일사 파트너스)</h2>
                            <br/><br/>
                            <br/><h3 className="text-sm font-semibold">제1조 (목적)</h3><br/>이 약관은 넷스프린트 주식회사(이하 “회사”라고
                            합니다)가 제공하는 Sales
                            Partnership 프로그램인 일사 파트너스를 Partner이 이용함에 있어서, 회사와 Partner 사이의 권리ᆞ의무, 책임사항, 서비스 이용절차 및 그 밖의
                            제반 사항을 명확히 하여 쌍방의
                            원활한 거래를 도모하고 궁극적으로 공동의 이익을 증진하여 상호 발전을 도모하는 것을 그 목적으로 합니다.<br/><br/>
                            <br/><h3 className="text-sm font-semibold">제2조 (용어의 정의)</h3><br/>이 약관에서 사용하는 용어의 정의는 다음과
                            같습니다. 이 약관에서 정의되지
                            않은 용어는 일반 거래 관행에 따라 정의된 의미를 가집니다.<br/><br/>
                            <ol className="list-decimal ml-4">
                                <li>“일사(ilsa)”이란 회사가 컴퓨터, 스마트폰 등 정보통신설비를 이용하여 판매자와 이용자가 재화 또는 용역을 거래할 수 있도록 통신판매중개 서비스를
                                    제공하는 가상의
                                    영업장((http://www.ilsaram.co.kr 등 회사가 운영하는 웹사이트 및 모바일 웹, 앱 등을 모두 포함)을 의미합니다.
                                </li>
                                <li>“일사 파트너스(이하 “일사 파트너스”라고 합니다)”란 회사가 제공하는 client acquisition를 Partner이 운영하는 sales
                                    channels에 게재하여
                                    potential clients의 관심에 의해 발생한 client acquisition 클릭을 통해 회사가 얻은 sales revenue을 회사”와
                                    “Partner”이 일정한
                                    비율로 분배하는 client acquisition서비스 및 이에 부수되는 제반 서비스를 의미합니다.
                                </li>
                                <li>“Partner”이란 회사가 제공하는 client acquisition 등을 자신의 sales channels에 게재하고, 일사 내 공유하기 기능을
                                    통해 그 성과에 대한 수입을
                                    취할 목적으로 이 약관에 동의하고 서비스 가입자로 승인을 받은 자를 의미합니다. Partner은 개인이나 법인 모두 가능하며 성과에 대해 회사로부터
                                    약정된 대가를 받게 됩니다.
                                </li>
                                <li>“potential clients”란 컴퓨터 또는 모바일기기 등 디바이스를 통해 Partner의 sales channels에 방문한 자를
                                    의미합니다.
                                </li>
                                <li>“sales channels”란 이 약관에 따라 회사의 client acquisition를 게재하는 매체로 Partner이 운영하는 블로그, 웹사이트
                                    등을 의미합니다.
                                </li>
                                <li>“수입”이란 회사의 client acquisition를 Partner의 sales channels에 게재하여 매출이 발생했을 때 회사가
                                    Partner에게 지급하게 되는 금액을
                                    의미합니다.
                                </li>
                                <li>“일사캐시”란 일사에서 상품 등을 구매할 때 사용할 수 있는 결제 수단을 의미합니다.</li>
                                <li>“부당한 수입”이란 Partner이 약관, 운영정책, 또는 관련 법령 등을 위반하거나 potential clients가 약관, 운영정책 또는
                                    관련법령에서 금지한 행위를 하여
                                    Partner에게 발생한 수입을 의미합니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제3조 (약관의 명시, 효력 및 개정)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 이 약관의 내용을 Partner이 알 수 있도록 서비스의 관련 화면(파트너스 사이트 내 ‘약관 및 정책’)을 통해 게시합니다.</li>
                                <li>회사는 이 약관에서 규정되지 않은 세부적인 내용을 별도의 “일사 파트너스 운영 정책(이하 “운영정책“이라 합니다)“으로 규정할 수 있고, 이를 서비스의
                                    관련 화면 등을 통하여
                                    공지하기로 합니다. 또한, 이러한 운영정책은 이 약관의 일부를 구성하며, 이 약관과 동일한 효력이 있습니다.
                                </li>
                                <li>본 약관과 관련하여, 별도 합의가 필요한 경우 서면에 의해야 합니다. 별도 합의한 내용이 본 약관과 상이한 경우, 본 약관에 우선합니다.</li>
                                <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 이 약관(또는 운영정책, 이하 동일함)을 개정할 수 있습니다.</li>
                                <li>회사가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 그 적용일자 7일 이전(Partner에게 불리한 내용으로 변경할
                                    때에는 14일 이전)부터
                                    적용일자 전일까지 서비스의 관련 화면에 공지하거나 전자우편 또는 그 밖의 방법으로 통지합니다.
                                </li>
                                <li>회사가 전항에 따라 개정 약관을 공지하면서 Partner에게 적용일자 전일까지 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게
                                    공지 또는 통지하였음에도
                                    판매자가 명시적으로 거부의 의사표시를 하지 아니한 경우에는 Partner이 개정 약관에 동의한 것으로 봅니다.
                                </li>
                                <li>Partner은 개정 약관에 동의하지 않는 경우 적용일자 전일까지 회사에 거부의사를 표시하고 가입을 해지할 수 있습니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제4조(Partner가입)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>Partner가입은 일사 파트너스 사이트(https://partners.ilsaram.co.kr)를 통해 서비스를 이용하고자 하는 자(이하
                                    "가입신청자"라고 합니다)가 회사가 정한
                                    가입 양식에 따라 Partner정보를 기입한 후 이 약관에 동의한다는 의사표시를 하면, 회사가 이러한 신청에 대하여 승낙함으로써 체결됩니다.
                                </li>
                                <li>회사는 가입신청자의 신청에 대하여 아래 각 호의 사유가 있는 경우에는 승낙을 하지 않을 수 있으며, 가입 이후에도 아래 각 호의 사유가 확인될 경우에는
                                    이 약관을 해지할 수
                                    있습니다.
                                </li>
                                <ol className="list-decimal ml-4">
                                    <li>가입신청자가 일사 Partner이 아닌 경우.</li>
                                    <li>가입신청자가 일사에 소속된 직원이거나 그 직계 가족일 경우.</li>
                                    <li>가입신청자가 이 약관에 의하여 이전에 "Partner" 자격을 상실한 적이 있는 경우.</li>
                                    <li>가입신청자가 이 약관 위반 등의 사유로 서비스 이용제한 중에 재가입신청을 하는 경우.</li>
                                    <li>가입신청자가 이미 서비스에 가입이 되어 있는 경우.</li>
                                    <li>실명이 아닌 명의 또는 타인의 명의를 기재한 경우.</li>
                                    <li>허위 또는 잘못된 정보를 기재 또는 제공하거나 회사가 정한 신청 요건이 미비한 경우.</li>
                                    <li>가입신청자의 귀책사유로 인하여 승낙이 불가능하거나 기타 이 약관에서 규정한 제반 사항을 위반하여 신청을 하는 경우.</li>
                                </ol>
                                <li>본 조에 따른 신청에 대하여 회사는 본인확인기관을 통한 본인확인을 가입신청자에게 요청할 수 있습니다.</li>
                                <li>Partner가입은 회사의 승낙이 이용신청자에게 도달한 때 완료됩니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제5조(정산방식)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 서비스를 통하여 측정된 실적과 그에 따라 별도로 정한 sales revenue 배분 기준에 따라 CPS(Cost Per Sale) 방식으로
                                    산정된 수입을 Partner에게
                                    지급합니다.
                                </li>
                                <li>수입 지급은 1일부터 말일 기준 1개월 단위를 원칙으로 하며, 취소 및 반품된 금액은 수입에서 모두 제외됩니다.</li>
                                <li>수입지급의 최소 금액은 10,000원이며, 월간 수입이 10,000원을 넘지 않을 경우에 정산 금액은 이월 처리됩니다. 금액 미달로 인한 최대 이월
                                    가능 기간은 6개월이며, 그
                                    이후에는 6개월간 적립된 금액이 일괄 지급됩니다.
                                </li>
                                <li>별도로 정하지 않은 경우, 수입 지급의 최대 금액은 1개월 기준 3,000만원이며, 이를 초과하여 발생한 수입은 이월되거나 지급되지 않습니다.</li>
                                <li>Partner이 사업자가 아닌 경우 회사는 수입 지급 금액에 따라 발생하는 제세공과금 등을 수입에서 공제하고 지급할 수 있습니다.</li>
                                <li>지급 과정에서 Partner의 은행계좌정보 등이 유효하지 않아 수입을 지급받지 못하는 경우 귀책사유는 Partner에게 있으며 회사는 이를 보상하지
                                    않습니다.
                                </li>
                                <li>전항의 사유로 수입이 지급되지 않은 경우 회사는 제18조에 따라 Partner에게 통지하며, 회사는 Partner이 은행계좌정보를 수정할 때까지 최대
                                    6개월까지 수입의 지급을
                                    보류할 수 있습니다.
                                </li>
                                <li>회사는 수입 지급 및 세무처리를 위하여 개인식별정보의 수집 동의, 세금계산서 등 조세 관련법령에서 규정하는 세무적 증빙의 발행을 요청할 수 있으며,
                                    Partner이
                                    개인식별정보수집에 동의하지 않거나 세금계산서를 승인 기간 내에 승인하지 않는 경우 또는 Partner이 제공한 정보가 유효하지 않은 경우 회사는 수입의
                                    지급을 보류할 수 있습니다.
                                </li>
                                <li>Partner은 수입 잔액이 0원 미만이 되는 경우, 해당 금액을 회사에 변제하여야 합니다.</li>
                                <li>회사는 부당한 수입에 대해 지급을 거절할 수 있으며 이미 지급된 경우 해당 "부당한 수입"을 Partner으로부터 회수할 수 있습니다.</li>
                                <li>회사는 신고 등에 의해 부당한 수입으로 의심될 경우, 이에 대한 확인을 위해 조사에 착수할 수 있으며, 조사가 완료될 때까지 수입의 지급을 보류할 수
                                    있습니다.
                                </li>
                                <li>Partner 또는 회사가 이 약관 해지 의사를 표시한 경우, 회사는 해지 의사를 표시한 날까지의 수입(이하 잔여수입이라고 합니다)을 확인하여,
                                    잔여수입이 회사가 정한 지급 기준액
                                    이상이 되는 경우 Partner에게 지급합니다. 구체적인 지급 방법 및 시기는 운영정책에서 정합니다.
                                </li>
                                <li>이용제한 또는 휴•폐업 상태에 있는 Partner에게는 수입의 지급이 제한될 수 있습니다.</li>
                                <li>그 외 구체적인 기준은 운영정책에서 정합니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제6조 (개인정보의 보호)</h3><br/>회사는 『정보통신망 이용촉진 및 정보보호 등에
                            관한 법률』,
                            『개인정보보호법』 등 관계 법령이 정하는 바에 따라 Partner의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호 및 사용에 대해서는 관련법령 및 회사의
                            개인정보처리방침이 적용됩니다.
                            다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다. <br/><br/>
                            <br/><h3 className="text-sm font-semibold">제7조 (회사의 의무)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 관련 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 이 약관이 정하는 바에 따라 지속적이고 안정적으로 서비스를 제공하기
                                    위하여 최선을 다하여
                                    노력합니다.
                                </li>
                                <li>회사는 Partner이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함) 보호를 위하여 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고
                                    준수합니다.
                                </li>
                                <li>회사는 서비스 이용과 관련하여 Partner으로부터 제기된 의견이나 불만이 정당하다고 인정될 경우에는 Partner의 불만을 해결하기 위해
                                    노력합니다.
                                </li>
                                <li>회사는 회사가 별도로 정한 client acquisitionsales revenue 배분기준 및 지급절차에 따라 수입을 Partner에게
                                    지급합니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제8조 (Partner의 의무)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>Partner은 관련 법령, 이 약관의 규정, 회사의 이용정책, 이용안내, 소명/시정 요구 등 회사가 통지하는 사항을 준수하여야 하며, 기타 회사
                                    업무에 방해되는 행위를 하여서는
                                    안 됩니다.
                                </li>
                                <li>Partner은 다음 각호의 행위를 하여서는 안 됩니다.</li>
                                <ol className="list-decimal ml-4">
                                    <li>Partner가입을 신청하거나 Partner정보 변경 신청 시 허위 또는 타인의 정보를 입력하는 행위</li>
                                    <li>회사 또는 제3자의 저작권 등 지식재산권을 침해하는 행위</li>
                                    <li>회사 또는 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                                    <li>회사 또는 제3자를 가장 또는 사칭하여 허가 받지 않은 게시판, 스팸메일 등의 활용으로 회사의 명성에 해를 끼치는 행위</li>
                                    <li>회사의 서비스에 게시된 정보를 변경하거나 서비스를 이용하여 얻은 정보, 공개되지 말아야 할 기밀정보(클릭 수, CTR, PPC 등)를 회사의
                                        사전 서면 승낙 없이 영리 또는
                                        비영리의 목적으로 복제, 출판, 방송 등에 사용하거나 제3자에게 제공하는 행위
                                    </li>
                                    <li>부정한 방법을 사용하여 client acquisition를 노출시키거나 클릭을 반복하여 회사에게 손해를 주거나 자신 또는 제3자에게 이익을 주는
                                        행위, 또는 타인에게 그러한
                                        행위를 유도하는 행위
                                    </li>
                                    <li>수신자의 사전 동의를 얻지 않은 불법 스팸 전송 행위 일체</li>
                                    <li>client acquisition의 게재를 유도하기 위해 sales channels의 콘텐츠 내용과 관계없이 무의미한 키워드를 반복하여 사용하는
                                        행위
                                    </li>
                                    <li>일사 파트너스에 등록되지 않은 sales channels에 서비스 이용을 위해 회사로부터 제공받은 이미지, 상표, 데이터 등을 포함한
                                        client acquisition를
                                        노출시키거나 일사의 도메인이름(ilsaram.co.kr)과 유사한 도메인을 이용하여 sales revenue을 발생시키는 행위
                                    </li>
                                    <li>계정을 매매, 양도, 명의변경, 재 판매하거나 질권의 목적으로 사용하는 행위</li>
                                    <li>서비스 이용 권한을 타인에게 공유, 제공, 양도, 중개, 재 판매하는 행위</li>
                                    <li>본 약관 상 의무를 회피하기 위해 중복계정, 타인명의 계정 등을 활용하여 서비스를 이용하는 행위</li>
                                    <li>서비스 내에 게재된 client acquisition의 내용, 링크, 순서 및 이에 포함된 정보 등을 변경, 조작하는 등의 행위.</li>
                                    <li>Partner이 회사와 계약된 방법 이외의 부정한 sales revenue을 추구하여 회사에 고의적인 손실을 입히는 행위.</li>
                                    <li>potential clients에게 금품을 제공하는 등 기타의 방법으로 일사보다 더 낮은 가격으로 상품을 구매할 수 있도록 유인하는 행위.
                                    </li>
                                    <li>본 서비스 제공 취지에 반하여 potential clients의 관심이 아닌 Partner이 발생시킨 client acquisition 클릭이나
                                        본인 및 가족 구매를 통해
                                        sales revenue을 발생시키는 행위
                                    </li>
                                    <li>일사이 그 권리를 보유하고 있는 표장 및/또는 이와 혼동을 일으킬 정도로 유사한 단어와 동일하거나 유사한 상표를 일사의 영업과 오인, 혼동을
                                        일으키는 방식으로
                                        상표/상호/도메인으로써 사용하는 행위
                                    </li>
                                    <li>Partner이 sales channels에 사실과 다르거나, 과장∙왜곡∙오인의 가능성이 있는 내용을 표시하는 등 표시client
                                        acquisition법 기타 관련 법령에
                                        위반되는 내용을 게시하는 행위
                                    </li>
                                    <li>Partner이 제3자 컨텐츠 등에 해당 컨텐츠의 의도와 상관없는 내용이나 회사의 이미지/사업 등에 손실을 끼치는 내용 등의 댓글을 게시하는
                                        행위
                                    </li>
                                    <li>해당 게시물과 관계없는 브랜드 및 제품명 등 제품정보를 언급하여 제3자에게 피해를 끼치거나 끼칠 우려가 있는 행위</li>
                                    <li>일사에 공식적으로 공개되지 않은 프로모션 등을 client acquisition하는 행위<br/> 22. 일사 파트너스의 이용 목적 및 기타
                                        서비스의 운영정책에 위배되는
                                        모든 행위
                                    </li>
                                </ol>
                                <li>회사는 Partner이 본 조항을 위반한 경우, Partner의 소명/시정을 요청할 수 있습니다. 이러한 경우, Partner은 소명/시정 요청을 받은
                                    기간 (단, 불가피한 사유로
                                    회사가 Partner의 제출 기간 연장 요청에 동의한 경우에는 그 기간) 이내에 관련 소명을 제출하거나 회신하여야 합니다.
                                </li>
                                <li>Partner은 본 조항에 명시된 의무를 이행하지 못하여 더 이상 일사 파트너스 활동을 지속하기 어렵다고 판단되는 경우, 회사는 일사 파트너스 활동을
                                    제한하는 등의 조치를 취할 수
                                    있습니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제9조 (Partner정보 변경)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>Partner은 가입신청 시 기재한 Partner정보에 변경이 있는 경우, Partner정보 수정 등의 방법으로 그 변경사항을 반영하여야 하며, 정산과
                                    관련된 주요 정보(개인정보,
                                    사업자정보, 계좌정보 등)를 변경할 경우, 회사에 별도로 통지하여야 합니다.
                                </li>
                                <li>연락처(전화번호, 이메일 주소 포함)가 변경되는 경우에는 즉시 전화번호, 이메일 주소 정보를 수정하고, 주기적으로 연락처가 유효한지 확인하여야
                                    합니다.
                                </li>
                                <li>Partner이 전항을 준수하지 않아 발생하는 Partner의 손해에 대하여 회사는 아무런 책임을 지지 않습니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제10조 (아이디 및 비밀번호의 관리)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>일사 파트너스의 경우 client acquisitionPartner의 고유 아이디는 회사에서 자동으로 부여합니다.</li>
                                <li>아이디와 비밀번호에 대한 모든 관리책임은 Partner에게 있으며, Partner은 이를 제3자가 이용하도록 하여서는 안됩니다.</li>
                                <li>아이디와 비밀번호의 관리소홀, 부정사용에 의하여 발생하는 모든 결과에 대한 책임은 Partner에게 있습니다.</li>
                                <li>Partner은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고 회사의 안내에 따라야 합니다.
                                </li>
                                <li>Partner이 전항을 준수하지 않아 발생한 불이익에 대하여 회사는 아무런 책임을 지지 않습니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제11조 (서비스의 변경)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 안정적인 서비스 제공을 위하여 서비스의 내용, 운영상 또는 기술상 사항 등을 변경할 수 있습니다.</li>
                                <li>회사는 서비스를 변경할 경우 변경내용과 적용일자를 명시하여 서비스 내에 사전 공지합니다. 단, Partner의 권리나 의무 및 서비스 이용과 관련되는
                                    실질적인 사항을 변경할 경우
                                    적용일자 7일전부터 공지하며, Partner에게 불리한 변경의 경우 적용일자 14일전부터 공지합니다.
                                </li>
                                <li>Partner은 서비스 변경에 동의하지 않을 경우 회사에 거부의사를 표시하고 Partner 탈퇴를 할 수 있습니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제12조 (Partner의 게시물)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>Partner은 자신이 운영하는 sales channels 및 게재한 게시물의 내용이 회사 또는 제3자의 권리에 대한 침해나 지식재산권 및 관련 법령에
                                    대한 위반이 되지 않음을
                                    보증하여야 합니다.
                                </li>
                                <li>Partner이 본 조 제1항을 위반하거나 회사가 규정한 게시물 또는 client acquisition물 규격을 지키지 않는 등 이 약관을
                                    위반(운영정책에서 정한 제한행위 모두
                                    포함)하는 경우, 회사는 Partner에게 이에 대한 시정요구 등을 할 수 있으며, Partner이 이를 거부하는 경우 회사는 서비스 이용제한,
                                    Partner 자격상실 등의 조치를
                                    임의적으로 취할 수 있습니다.
                                </li>
                                <li>Partner이 본 조를 위반하여 제3자의 권리를 침해하거나 지식재산권 및 관련 법령에 위반하였다는 이유로 회사가 금지청구, 손해배상청구, 고소 등
                                    법적 조치를 당할 경우에는
                                    자신의 비용으로 회사를 면책시켜야 합니다. 이와 관련하여 회사가 제3자에게 손해배상책임을 부담하는 경우에는 회사의 손해배상액 및 그 배상과 관련된
                                    부대비용 등(이자 및 변호사 보수
                                    등의 방어비용 포함)을 Partner이 전적으로 부담합니다.
                                </li>
                                <li>Partner은 자신이 운영하는 sales channels에 상품 추천의 내용이 포함된 게시물을 게재할 경우, 공정거래위원회의 ‘추천·보증 등에 관한
                                    표시·client
                                    acquisition 심사지침’에 따라 추천·보증인인 Partner과 회사의 경제적 이해관계에 대하여 공개하는 등 관련 법령 및 행정청의 가이드에 따른
                                    의무를 준수하여야 합니다.
                                </li>
                                <li>본조에도 불구하고 Partner은 지식재산권 침해 등 이용약관 및 운영정책을 위반하는 콘텐츠가 포함된 게시물이 발견되는 즉시 책임지고 삭제하여야
                                    합니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제13조 (서비스의 중단)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 컴퓨터 등 정보통신설비의 보수, 점검, 교체, 고장 또는 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수
                                    있습니다.
                                </li>
                                <li>회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스의 제공을 제한하거나 일시 중단할 수 있습니다.</li>
                                <li>회사는 제1항 및 제2항에 따른 서비스 중단의 경우에는 그 사실과 사유를 사전에 공지합니다. 단, 사전에 공지하기 어려운 사정이 있는 경우에는 사후
                                    가능한 시점에 공지합니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제14조 (실적 측정)</h3><br/>Partner의 sales channels를 통해
                            발생하는 모든 실적 집계는
                            회사에서 제공되는 실적 측정을 기준으로 하며, Partner은 이에 대해 이의를 제기할 수 없습니다.<br/><br/>
                            <br/><h3 className="text-sm font-semibold">제15조 (데이터의 수집 및 이용)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 서비스를 제공함에 있어 비정상적인 방법의 client acquisition 여부 판단 등을 위하여 OS와 디바이스의 정보를 수집할 수 있습니다.
                                    "회사"는 수집하는 데이터의
                                    주요 항목에 대해서는 운영정책에서 정합니다.
                                </li>
                                <li>회사는 전항에 따라 수집한 정보를 회사가 제공하는 서비스 등을 위하여 이용할 수 있으며, 관련 법령에 따라 제3자에게 제공할 수 있습니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제16조 (이용제한 등)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 Partner이 관련법령, 이 약관 또는 운영정책상 의무를 위반하거나 기타 서비스의 정상적인 운영을 방해하는 경우 또는 Partner이 운영하는
                                    sales channels가
                                    운영정책에서 정한 기준에 따라 client acquisition매체로써의 기능이 현저히 떨어진다고 판단될 경우 client acquisition 게재
                                    중지, sales
                                    revenue금 지급 중지, Partner자격 상실 등 단계적으로 이용을 제한할 수 있습니다.
                                </li>
                                <li>회사는 전항에도 불구하고 Partner이 주민등록법, 저작권법 및 정보통신망이용촉진 및 정보보호 등에 관한 법 등을 위반한 경우 또는 회사의
                                    지식재산권을 침해하는 활동이 발견되는
                                    경우, 비정상적인 댓글 활동(예를 들어 원작 게시글의 의도와 맞지 않는 Partner의 무분별한 홍보 활동 등)이 발견되는 경우, 일사에 공식적으로
                                    공개되지 않은 프로모션 등을
                                    client acquisition하는 경우, 서비스 운영에 악영향을 미치는 경우(예를 들어 반복적 버그 악용 및 자동화된 프로그램을 통한 클릭 발생
                                    등)에는 사전 통지 없이
                                    sales revenue금 지급이 중지되며, 즉시 Partner자격 상실 조치를 하거나 직권 해지할 수 있습니다.
                                </li>
                                <li>회사는 판매자로부터 제품과 관련된 민원 등이 인입되는 경우에 Partner에게 게시물의 노출 중단/삭제 등을 요청할 수 있으며, 이에 응하지 않을 경우
                                    회사는 본조 제1항에 따라
                                    단계적으로 조치를 취할 수 있습니다.
                                </li>
                                <li>회사는 Partner이 휴업 또는 폐업 상태의 사업자로 확인될 경우 client acquisition 게재를 중지할 수 있습니다.</li>
                                <li>회사가 Partner에게 이용제한을 하는 경우 회사는 이 약관 제18조에 따라 Partner에게 통지합니다.</li>
                                <li>Partner은 회사의 이용제한에 대해 회사가 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 회사가 인정하는 경우 회사는 해당
                                    조치를 철회할 수
                                    있습니다.
                                </li>
                                <li>회사가 행하는 이용제한의 세부내용은 운영정책에서 정합니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제17조 (해지)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>Partner은 언제든지 직접 서비스에 접속하여 이 약관의 해지를 신청할 수 있으며, 회사는 관련 법령이 정하는 바에 따라 이를 즉시 처리하여야
                                    합니다. 다만, Partner의
                                    미정산 수입이 있는 경우 회사는 미정산 수입을 차후 지급합니다.
                                </li>
                                <li>본 조 제1항의 경우 Partner은 이 약관의 해지일 이후 재가입 신청을 할 수 있습니다. 또한, 재가입하는 경우에도 Partner의 기존의 이용
                                    기록이 승계되지는 않습니다.
                                </li>
                                <li>회사는 Partner에게 다음 각 호의 어느 하나에 해당하는 사유가 있는 경우에는 해당 Partner과의 이 약관을 해지할 수 있습니다. 이 경우
                                    Partner에게 의견제출의
                                    기회를 사전에 부여할 수 있습니다.
                                </li>
                                <ol className="list-decimal ml-4">
                                    <li>회사 또는 제3자의 권리, 명예, 신용 및 그 밖의 정당한 이익을 침해하거나 관련 법령 또는 공서양속에 위배되는 행위를 한 경우</li>
                                    <li>회사가 제공하는 서비스의 원활한 진행을 방해하는 행위를 하거나 시도한 경우</li>
                                    <li>제4조에 따른 승낙거부사유가 있는 경우</li>
                                    <li>Partner이 회사로부터 요청 받은 정보 또는 증빙자료를 제공하지 아니하거나 허위로 제공한 경우</li>
                                    <li>이 약관 등에서 금지 또는 제한행위(등록제한, 이용제한 행위 등 모두 포함)를 한 경우</li>
                                    <li>이 약관에 따른 의무를 위반한 경우</li>
                                    <li>그 밖에 회사가 합리적인 이유로 서비스의 제공을 거부할 수 있는 경우</li>
                                </ol>
                                <li>당사자 일방은 상대방에게 다음 각 호의 어느 하나에 해당하는 사유로 인하여 이 약관을 정상적으로 이행할 수 없게 된 경우에는 그 상대방에게 별도의 최고
                                    없이 해지의 통지를 함으로써
                                    이 약관을 해지할 수 있습니다.
                                </li>
                                <ol className="list-decimal ml-4">
                                    <li>이용계약에 따른 의무를 위반하고 이를 시정하지 아니한 경우</li>
                                    <li>부도 등 금융기관의 거래정지, 회생 및 파산절차의 개시가 있거나 이에 해당할 상당한 우려가 있는 경우</li>
                                    <li>법률, 법원의 판결이나 명령, 영업정지 및 취소 등의 행정처분, 또는 행정지도 등 정부의 명령 등</li>
                                    <li>가압류, 압류, 가처분, 경매 등의 강제집행 등</li>
                                    <li>주요 자산에 대한 보전처분, 영업양도 및 합병 등</li>
                                </ol>
                                <li>본 조 제3항 및 제4항에 따라 해지된 Partner 또는 이용제한 기간 중 해지한 Partner은 재가입이 제한될 수 있습니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제18조 (Partner 통지)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사가 Partner에 대하여 통지를 하는 경우 이 약관에 별도의 규정이 없는 한 Partner이 제공한 전자우편주소, (휴대)전화번호 등으로 할 수
                                    있습니다.
                                </li>
                                <li>회사는 Partner 전체에 대하여 통지를 하는 경우 7일 이상 서비스 내 게시판에 게시함으로써 전항의 통지에 갈음할 수 있습니다. 다만,
                                    Partner의 서비스 이용에 중대한
                                    영향을 주는 사항에 대하여는 개별 통지합니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제19조 (지식재산권 등)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사가 제공하는 서비스와 관련하여 회사가 자체적으로 제작한 저작물(Partner으로부터 제공받은 상품콘텐츠를 활용하여 회사가 제작한 2차적 저작물을
                                    포함)에 관한
                                    지식재산권(특허ㆍ실용실안ㆍ디자인ㆍ상표권과 저작권 포함)은 회사에게 있으며, Partner이 이를 회사의 사전 서면 승인 없이 사용한 경우
                                    Partner은 민·형사상 모든 책임을
                                    부담합니다.
                                </li>
                                <li>Partner이 작성한 콘텐츠, 게시물 등은 Partner의 동의 없이 회사가 제공하는 서비스 및 관련 프로모션 등에 노출되거나 해당 노출을 위해
                                    필요한 범위 내에서 일부 수정,
                                    복제, 편집되어 게시될 수 있습니다.
                                </li>
                                <li>본 조의 내용은 이 약관이 종료 이후에도 유효하게 존속합니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제20조 (손해배상 등)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 서비스 이용과 관련하여 회사의 고의 또는 과실로 인해 Partner에게 손해가 발생한 경우 관련 법령이 규정하는 범위 내에서 Partner에게
                                    그 손해를 배상합니다.
                                </li>
                                <li>Partner이 이 약관 또는 관련 법령을 위반하여 회사에 손해가 발생한 경우 관련 법령이 규정하는 범위 내에서 회사에 그 손해를 배상합니다.</li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제21조 (회사의 면책)</h3><br/>
                            <ol className="list-decimal ml-4">
                                <li>회사는 천재지변, 디도스(DDOS)공격, IDC장애, 기간통신사업자의 회선 장애, sales channels의 장애 또는 이에 준하는 불가항력으로
                                    인하여 서비스를 제공할 수 없는
                                    경우에는 서비스 제공에 관한 책임을 지지 않습니다.
                                </li>
                                <li>회사는 Partner의 귀책사유로 인한 서비스 이용 장애에 대하여는 책임을 지지 않습니다.</li>
                                <li>회사는 Partner이 서비스를 이용하여 얻은 정보 등으로 인하여 입은 손해에 대하여 책임을 부담하지 않습니다.</li>
                                <li>Partner이 등록한 sales channels의 내용, 영업 등에 대한 모든 책임은 Partner에게 있으며 회사는 이에 대하여 책임을 지지
                                    않습니다.
                                </li>
                            </ol>
                            <br/>
                            <br/><h3 className="text-sm font-semibold">제22조 (준거법 및 관할법원)</h3><br/>이 약관의 해석 및 회사와
                            Partner간의 분쟁에 대하여는
                            대한민국의 법률을 적용합니다.<br/>이 약관 및 "서비스" 이용과 관련하여 회사와 Partner 사이에 분쟁이 발생하여 소송이 제기되는 경우에는 「민사소송법」에
                            따라 관할법원을
                            정합니다.<br/>
                        </div>
                    }
                    {
                        activeTab === 'policy' && <div>
                            <br/><h2 className="text-sm font-bold">일사 마케팅 제휴 프로그램 운영정책</h2>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스는 공정한 서비스 유지 및 이용자 보호를 위해 다음의 정책에 따라 서비스를 운영하고 있습니다. 일사 파트너스 가입 신청자와 가입 회원은 다음의 운영정책을 반드시 확인하고 동의 및 준수하셔야 하며, 운영정책을 준수하지 않음으로 인해 서비스 이용에 제한을 받으시는 일이 없도록 주의하여 주시기 바랍니다.</span>
                            </p>
                            <p><br/><br/><br/></p>
                            <ol>
                                <li><span><b>회원가입</b></span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스는 다음의 기준에 따라 가입 여부를 심사하고 있습니다.</span></p>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;</span></p>
                            <p><span>1.1.가입심사</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li>
                                    <span> 일사 회원이라면 누구나 일사 파트너스 서비스 신청이 가능합니다. 단, 미성년자나 비영리법인, 면세사업자, 외국인의 경우 신청이 거절될 수 있습니다.</span><span><br/></span>
                                    <span><br/></span>
                                    <span><ul className="list-disc ml-4"> <li>서비스 신청 이후 회사가 사전에 안내한 일정 금액의 수익 발생 시 해당 회원의 채널을 검토하여 최종승인 여부를 결정합니다.
                            <br/>가입 신청자의 자격요건은 다음 기준에 의해 심사합니다.
                        </li></ul></span></li>
                            </ul>
                            <p>&nbsp; &nbsp; 1) 개인회원(사업자가 아닌 회원)</p>
                            <p className="ml-7"><span>개인으로 가입을 원하는 자는 실명확인 절차를 거쳐 서비스 가입이 가능합니다.</span></p>
                            <p>&nbsp; &nbsp; 2) 사업자인 회원</p>
                            <p className="ml-7">
                                <span>사업자로 가입을 원하는 자는 사업자정보의 유효성과 계정 및 사업자정보 일치 여부 확인을 위해 별도의 서류를 제출해야 합니다. (사업자등록증 사본)</span>
                            </p>
                            <ul>
                                <li className="ml-7 pl-1 list-['※']"> 명의도용 방지를 위해 일사 회원 가입자명과 개인사업자의 대표자명은 동일한 경우에 한해
                                    가입이 허용됩니다.
                                </li>
                            </ul>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;1.2. 가입제한</span></p>
                            <p><span>일사 파트너스는 안정적인 서비스 운영 및 회원의 이익 보호를 위해 다음의 경우 서비스 가입을 제한할 수 있습니다.</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 가입신청자가 일사 파트너스 약관 및 운영정책에 어긋나는 행동을 한 후 자진하여 탈퇴한 적이 있는 경우</span></li>
                                <li><span> 가입신청자가 일사 파트너스 약관 및 운영정책에 어긋나는 행동을 하여 직권해지 된 적이 있는 경우</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>1.3. 정보변경</span></p>
                            <p>&nbsp;</p>
                            <p><span>회원은 정보변경페이지에서 본인의 정보를 열람하고 변경할 수 있습니다. 단, 다음에 해당하는 항목은 변경이 제한됩니다.</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 아이디, 이름, 주민등록번호, 사업자등록번호는 변경할 수 없습니다.</span></li>
                                <li><span> 대표자명 등 사업자정보를 변경하고자 하는 경우 회사가 요구하는 증빙 제출 및 심사를 통해 정보변경이 가능합니다.</span></li>
                                <li><span> 일사 회원가입자명과 개인사업자의 대표자명을 서로 다르게 변경할 수 없습니다.</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <ol start="2">
                                <li><span><b>미디어등록기준</b></span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스 서비스를 이용하기 위해서는 광고가 노출될 미디어를 등록하여야 합니다. 회원이 등록 신청한 미디어에 대해 광고매체로서의 적합성 여부 등을 심사하며, 이용약관 및 운영정책에 위배되는 사항이 발견될 경우 등록을 거절 또는 취소할 수 있습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>2.1. 공통 등록기준</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 회원의 미디어에 대한 광고매체로써의 품질을 평가하기 위해 아래 내용을 종합적으로 심사합니다.</span></li>
                            </ul>
                            <ul className="list-['-'] ml-2">
                                <li className="pl-1">미디어 운영기간 및 이용가능한 전체 공개 콘텐츠의 수</li>
                                <li className="pl-1">광고매체로써의 콘텐츠 적합성, 등록제한 콘텐츠 존재 여부</li>
                            </ul>
                            <ul>
                                <li><span> 회원제로 운영되는 미디어의 경우 테스트ID 및 비밀번호를 검수 시 제공해야 합니다.</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>2.2. 등록제한</span></p>
                            <p>&nbsp;</p>
                            <p><span>다음의 내용이 확인되는 미디어는 등록이 거절되거나 취소될 수 있습니다.</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 성인콘텐츠, 성인용품, 성매매 또는 유흥업소 관련 내용</span></li>
                                <li><span> 애인대행 및 역할대행 서비스 관련 내용</span></li>
                                <li><span> 선정적이거나 혐오, 폭력적인 내용</span></li>
                                <li><span> 웹하드, P2P, 무료 음원 제공 관련 내용</span></li>
                                <li><span> 게임 아이템 거래 관련 내용</span></li>
                                <li><span> 도박, 카지노, 경륜, 경마 등 사행성이 포함된 내용</span></li>
                                <li><span> 대부업, 대부중개업 등 사금융 관련 내용</span></li>
                                <li><span> 흥신소, 심부름센터 관련 내용</span></li>
                                <li><span> 이미테이션 제품 홍보/판매 등 관련 내용</span></li>
                                <li><span> 복권 판매 내용</span></li>
                                <li><span> 총기, 도검류 판매 내용</span></li>
                                <li><span> 불법건강식품, 주류, 담배, 마약, 불법의약품 관련 내용</span></li>
                                <li><span> 해킹, 크래킹 관련 내용</span></li>
                                <li><span> 기타 불법 및 범죄적 행위에 결부 및 불법 행위를 조장하는 내용</span></li>
                                <li><span> 특정 개인이나 집단, 단체, 성별, 민족, 인종, 종교, 장애인 등에 대한 비방 및 차별 내용</span></li>
                                <li><span> 용공 등 이적 표현물</span></li>
                                <li><span> 광고 시청, 클릭 등의 콘텐츠 이용에 대해 보상을 제공하는 경우</span></li>
                                <li><span> 운영자 및 제3자의 저작권, 지식재산권을 침해한 내용</span></li>
                                <li><span> 공공질서 및 미풍양속에 위반되는 내용</span></li>
                                <li><span> 비정상적으로 트래픽을 유도하는 경우</span></li>
                                <li><span> 방문자에게 금품을 제공하는 등 기타의 방법으로 일사보다 더 낮은 가격으로 상품을 구매할 수 있도록 유인하는 행위</span></li>
                                <li><span> 기타 관련법령 및 이용약관, 운영정책에 위배되는 경우</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <ol start="3">
                                <li><span><b>데이터의 수집 및 이용</b></span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스 서비스를 제공함에 있어 어뷰징 여부의 판단, 광고의 타겟팅 등을 위해 필요할 경우 미디어와 Device의 정보를 수집할 수 있습니다. 수집하는 주요 항목은 다음과 같으며, 개인정보처리방침에서 규정하지 않은 개인정보는 수집하지 않습니다.</span>
                            </p>
                            <ul>
                                <li><span> OS의 종류 및 버전, 브라우저 정보, IP 정보 등</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <ol start="4">
                                <li><span><b>이용제한</b></span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스는 회원의 미디어가 서비스 이용약관 또는 운영정책에 위반되는 사항이 없는지 주기적으로 확인하며, 위반 사항이 확인되는 경우 이용제한 정책에 따라 회원의 서비스 이용을 일시적 또는 영구적으로 제한하고 있습니다. 정책 위반으로 인해 서비스 이용에 제한을 받으시는 일이 없도록 다음의 내용을 자세히 읽고 숙지하여 주시기 바랍니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>4.1. 이용제한 사유</span></p>
                            <p>&nbsp;</p>
                            <p><span>1) 기술적 금지 행위</span></p>
                            <p>&nbsp;</p>
                            <p><span>서비스의 안정적인 운영을 위해 어떠한 경우에도 다음의 행위를 금지하고 있습니다.</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 자사의 서버에 부하를 가하는 행위</span></li>
                                <li><span> 자사가 전송하는 광고의 링크, 형태, 갱신주기 및 이에 포함된 정보에 대한 별도의 조작 행위</span></li>
                                <li><span> 일사 파트너스에 등록되지 않은 미디어에 광고를 노출시키는 행위</span></li>
                                <li><span> 자사가 서비스 운영을 위해 수집하는 정보를 변경 또는 변형하는 행위</span></li>
                                <li><span> 자사가 지정한 가이드를 따르지 않거나 기타 부정한 방법으로 서비스 운영에 악영향을 미치는 행위</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>2) 무효클릭 및 이를 유도하는 행위</span></p>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스 광고에 대한 클릭은 방문자의 관심에 의해 발생한 것을 전제로 합니다. 매크로나 개별 사용자로부터 발생하는 무의미한 반복 클릭, 대량 클릭, '클릭유도' 문구 등으로부터 발생한 클릭과 같이 인위적으로 발생되는 클릭을 '무효클릭'으로 판단합니다. 일사 파트너스는 어떠한 방식으로든 무효클릭을 발생시키거나 이를 유도하는 행위를 엄격히 금지하고 있으며 자세한 내용은 다음과 같습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 회원 본인 또는 다른 회원의 미디어에 게재된 광고를 지속하여 반복적으로 클릭하는 행위</span></li>
                                <li>
                                    <span> 회원 본인 또는 다른 회원의 미디어에 게재된 광고를 방문자가 클릭하도록 유도하기 위한 문구, 도형, 이미지 등을 미디어 내에 포함하는 행위</span>
                                </li>
                            </ul>
                            <p><span>&nbsp; &nbsp; 예) "도와주세요", "링크를 클릭하세요" 등의 문구 삽입, 방문자의 성적 호기심을 불러일으킬 수 있는 선정적이거나 자극적인 이미지 등을 사용하여 광고에 대한 비정상적인 호기심을 발생시키는 경우 등</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 메일, 메신저, SMS 등을 이용하여 클릭을 요청하는 메시지를 발송하는 행위</span></li>
                                <li>
                                    <span> 수신자의 사전 동의를 얻지 않은 메일, 메신저, SMS 등을 이용하여 클릭을 요청하는 메시지를 발송하는 행위 등 불법 스팸 전송 행위 일체&nbsp;</span>
                                </li>
                                <li>
                                    <span> 로봇, 자동화된 클릭 및 노출 생성 도구, 자동 웹 브라우징, 클릭 교환 프로그램 등을 사용하여 인위적으로 클릭을 발생시키는 행위</span>
                                </li>
                                <li><span> 자사가 전송하는 광고를 사이트 또는 앱의 백그라운드에 숨겨 호출하는 행위</span></li>
                                <li>
                                    <span> 방문자의 액션을 유도하는 버튼 등을 광고영역과 매우 근접하게 위치시키거나 위젯, 레이어 등을 이용하여 방문자의 오클릭을 유도하는 행위</span>
                                </li>
                                <li><span> 기타 다양한 부정한 방법을 사용하여 광고에 대한 클릭을 반복시키는 행위</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>3) 인위적으로 특정 광고를 노출시키거나 게재를 유도하는 행위</span></p>
                            <p>&nbsp;</p>
                            <p><span>인위적으로 특정 광고를 노출시키거나 게재를 유도하는 다음과 같은 행위는 이용제한 사유로 규정하고 있습니다.</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 광고 유도를 목적으로 미디어의 내용과 관계 없는 무의미한 키워드를 삽입하는 행위</span></li>
                                <li><span> 프로그램을 이용하여 인위적으로 특정 광고를 노출시키거나 노출을 유도하는 행위</span></li>
                                <li><span> 해당 게시물과 관계없는 브랜드 및 제품명을 언급하여 제3자에게 피해를 끼치거나 끼칠 우려가 있는 행위</span></li>
                                <li><span> 기타 다양한 부정한 방법을 통해 광고의 노출 또는 게재를 유도하는 행위</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>4) 서비스의 기밀정보를 공개하는 행위</span></p>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스에서 제공하는 리포트의 통계 내용이 외부에 공개될 경우 서비스의 안정성을 해쳐 선의의 이용자 및 회사에 피해가 될 수 있습니다. 이에 다음과 같이 일부 통계 지표에 대해서는 외부 공개를 금지하고 있습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 일사 파트너스에서 제공하는 리포트 또는 통계 내용 중 기밀정보를 공개하는 행위</span></li>
                            </ul>
                            <ul className="list-['-'] ml-2">
                                <li className="pl-1">공개가능 정보: 일 수입 및 누적수입, 지급수입 등 수입정보(그래프 포함)</li>
                                <li className="pl-1">공개불가 정보: 노출수, 클릭수, 클릭률(CTR) 및 관련 그래프, 노출율</li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>5) 광고미디어 권한의 재 판매 행위</span></p>
                            <p>&nbsp;</p>
                            <p>
                                <span>회원은 당사로부터 부여 받은 광고미디어로서의 권한을 회사의 서면 동의 없이 타인 또는 타 매체에 공유, 제공, 양도, 중개, 재 판매 등을 할 수 없습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>6) 부적합 콘텐츠의 게시 행위</span></p>
                            <p>&nbsp;</p>
                            <p><span>회원은 회원이 운영하는 미디어에 다음에 명시하고 있는 부적합 콘텐츠를 포함하거나 관련 콘텐츠가 포함된 링크를 게재해서는 안되며, 이러한 콘텐츠에 광고가 노출되지 않도록 항시 주의하여 관리하여야 합니다. 부적합 콘텐츠가 확인되는 경우 이용약관 제16조에 따라 서비스 이용을 즉시 제한하고 있으며, 이를 책임지고 삭제하여야 합니다. 다음의 내용을 잘 숙지하여 미디어를 운영하여 주시기 바랍니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 개인정보 노출 게시물</span></li>
                            </ul>
                            <ul className="ml-6 list-['-']">
                                <li className="pl-1">타인의 개인정보(성명, 주민등록번호, 주소, 전화번호, 사진, 영상 등에 의하여 특정한 개인을 알아볼 수 있는 정보)를
                                    본인의 동의 없이 게시하는
                                    내용
                                </li>
                            </ul>
                            <ul>
                                <li><span> 지식재산권 위반 게시물</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">일사, 일사 파트너스를 사칭하여 하는 모든 활동</li>
                                <li className="pl-1">일사, 일사 파트너스의 지식 재산(BI, CI 등)을 활용한 모든 활동</li>
                                <li className="pl-1">일사, 일사 파트너스 키워드를 활용한 검색광고, 도메인 이름 등록, 보유, 사용</li>
                                <li className="pl-1">사전승인 없이 일사 로고를 무단 사용하는 경우</li>
                                <li className="pl-1">저작권자의 동의 없이 방송, 음원, 영화, 소설, 게임, 만화 등 저작물을 복제, 배포, 전송하는 경우</li>
                                <p>
                                    <span> 예) 음원 첨부/스트리밍, 방송사로고가 포함되어 있는 동영상 등을 포함한 게시물, 불법 다운로드 사이트로의 링크를 제공하는 게시물, 복제 CD 판매, 프리서버 홍보 등</span>
                                </p>
                                <li className="pl-1">기타 타인의 상표권, 디자인권 등 지식재산권을 무단으로 침해하는 경우</li>
                            </ul>
                            <p><span> 영리추구/홍보성 게시물</span></p>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">인터넷을 통한 매매 또는 광고가 금지되거나 제한된 제품을 매매/홍보하는 내용</li>
                                <li className="pl-1">철도, 승차권, 사용제한 상품권 등 발행자가 전매를 금지한 물품을 판매하거나 알선하는 내용</li>
                                <li className="pl-1">전문적/상설적으로 금전적 거래를 발생시키거나 이를 알선하는 내용</li>
                            </ul>
                            <ul>
                                <li><span> 불법성 게시물</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">범죄 관련 내용을 미화, 권유, 조장하는 내용.</li>
                                <li className="pl-1">살인을 청탁하거나 이를 권유, 유도 및 매개하는 내용</li>
                                <li className="pl-1">주민등록번호생성기, 카드번호생성기, 아이템생성기 등 불법자료를 올리는 경우</li>
                                <li className="pl-1">불법 제품을 이용자에게 판매하거나 소개하는 경우</li>
                                <li className="pl-1">불법적인 해킹 정보를 유통하는 경우</li>
                                <li className="pl-1">불법 다단계 영업행위, 유사 수신 등 허위사실이나 불법적 내용을 게시하는 경우</li>
                                <li className="pl-1">불법성 게시물을 게재하고 있는 타 사이트로 링크를 제공하는 경우</li>
                                <li className="pl-1">난자매매, 장기매매, 대리모 등의 신체와 관련된 금전 거래를 야기할 우려가 있는 내용</li>
                                <li className="pl-1">자살을 미화, 권유하거나 자살방법을 적시하는 내용, 동반자살을 유도하는 내용</li>
                                <li className="pl-1">도박 등의 사행심을 조장하는 내용</li>
                                <li className="pl-1">악성코드, 바이러스 등 이용자의 서비스 환경을 저해하는 프로그램 및 검색 어뷰징 등 회사의 업무를 방해하는 프로그램을
                                    수록하거나 설치를 유도,
                                    배포하는 경우
                                </li>
                                <li className="pl-1">시체 사진 등 혐오감을 주는 이미지를 수록하거나 해당 이미지로 링크시키는 경우</li>
                                <li className="pl-1">존속에 대한 상해 폭행 살인 등 전통적인 가족윤리를 훼손할 우려가 있는 내용</li>
                                <li className="pl-1">성폭력, 마약복용 등 퇴폐적 행위를 자극하거나 미화하는 내용</li>
                                <li className="pl-1">성폭력, 강간, 윤간 등 성범죄를 구체적/사실적으로 묘사하거나 미화한 내용</li>
                                <li className="pl-1">매춘, 사이버섹스, 노골적인 성적 대화 등 성적 유희 대상을 찾거나 매개하는 내용</li>
                                <li className="pl-1">음란정보 또는 퇴폐업소가 있는 장소를 안내 또는 매개하는 내용</li>
                                <li className="pl-1">타인의 신체를 본인의 의사에 반해 촬영 및 게시하여 성적 수치심을 유발하는 경우</li>
                            </ul>
                            <ul>
                                <li><span> 음란성 게시물 기타 사회윤리적으로 허용될 수 없는 게시물</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">남녀의 성기, 국부, 음모 또는 항문이 노출되거나 투명한 의상으로 속살이 비치는 내용</li>
                                <li className="pl-1">착의 상태라도 남녀의 성기 등이 지나치게 강조되거나 근접 촬영되어 윤곽 또는 굴곡이 드러난 내용</li>
                                <li className="pl-1">이성 또는 동성간의 정사, 구강성교, 애무, 자위행위 등 성행위를 직/간접적으로 묘사한 내용</li>
                                <li className="pl-1">수간, 혼음, 성고문 등 변태성욕을 묘사한 내용</li>
                                <li className="pl-1">어린이 또는 청소년을 성 유희의 대상으로 묘사한 내용</li>
                                <li className="pl-1">남녀의 성기를 저속하게 표현한 내용</li>
                                <li className="pl-1">불륜관계, 근친상간 등 반인륜적 성행위를 자세히 소개하거나 흥미 위주로 묘사한 내용</li>
                                <li className="pl-1">매춘 등 불법 성행위를 정당하게 묘사한 내용</li>
                                <li className="pl-1">음란하거나 선정적인 게시물을 게재하고 있는 타 사이트로 링크를 제공하는 경우</li>
                                <li className="pl-1">스와핑 등 사회 윤리적으로 용납되지 않은 행위를 매개하는 경우</li>
                                <li className="pl-1">청소년 유해약물 등의 효능 및 제조방법 등을 구체적으로 기술하여 그 복용 제조 및 사용을 조장하거나 이를 매개하는
                                    내용
                                </li>
                                <li className="pl-1">청소년에게 불건전한 교제를 조장할 우려가 있거나 이를 매개하는 내용</li>
                                <li className="pl-1">지나치게 선정적이거나 혐오스러운 내용</li>
                            </ul>
                            <ul>
                                <li><span> 기타</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1"> 단어/문구를 반복 삽입하는 등의 비정상적인 게시물</li>
                                <li className="pl-1">행운의 편지글, 스팸글, 홍보글 등의 도배성 내용</li>
                                <li className="pl-1">타인에 대한 욕설ㆍ비방으로 인해 방문자에게 피해를 주거나 불쾌감을 줄 수 있는 내용</li>
                                <li className="pl-1">가상화폐 관련 내용</li>
                                <li className="pl-1">타인의 개인정보 노출유도, 관리자를 사칭하는 내용</li>
                                <li className="pl-1">사실과 다르거나, 과장∙왜곡∙오인의 가능성이 있는 내용을 표시하는 등 표시광고법 기타 관련 법령에 위반되는 내용</li>
                                <li className="pl-1">기타 관련 법령에 위반되거나 건전한 미풍양속을 저해하는 내용</li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>7) 광고매체로써의 기능 저하</span></p>
                            <p>&nbsp;</p>
                            <p><span>일사 파트너스 회원은 자신의 미디어가 광고매체로써의 기능을 다하도록 꾸준히 관리하고 노력하여야 합니다. 회원의 미디어가 광고매체로써의 기능이 현저히 떨어진다고 판단될 경우 서비스 이용을 제한할 수 있습니다. 단, 회원 스스로 광고 게재를 중지한 경우는 제외합니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 해당 미디어에서 무효 클릭이 일정 기준 이상으로 지속적으로 발생하는 경우</span></li>
                                <li><span> 언론 매체, 댓글 또는 이용후기 등에서 미디어 또는 회원에 대한 다수의 부정적인 여론이 확인되는 경우</span></li>
                                <li><span> 콘텐츠가 업데이트 되지 않거나 관리가 되지 않아 서비스 이용가치가 심각하게 저하된 경우</span></li>
                                <li><span> 정상적인 미디어 접근 및 서비스 이용이 불가능한 경우(블로그 초기화, 호스팅 만료, 기능 이상 등)</span></li>
                                <li><span> 미디어 고유의 콘텐츠보다 일사 파트너스 광고를 포함한 기타 광고성 콘텐츠의 비중이 압도적으로큰 경우</span></li>
                                <li><span> 기타 이용자 관련 분쟁 등으로 인해 광고 노출이 부적절한 경우</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>4.2. 이용제한 정책</span></p>
                            <p>&nbsp;</p>
                            <p>
                                <span>일사 파트너스는 이용약관 및 운영정책 등에 명시한 이용제한 사유에 해당하는 행위가 확인될 경우 다음과 같이 서비스 이용을 제한하고 있습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>1) 회원계정에 대한 이용제한</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 회원이 등록한 미디어에서 이용제한 사유가 지속적으로 발생하거나, 서비스 운영에 악영향을 미칠 경우 회원의 계정에 대해 서비스 이용을 제한할 수 있습니다.</span>
                                </li>
                                <li><span> 회원의 계정이 '이용제한' 이 되면 회원이 등록한 모든 미디어에 대한 광고의 노출 및 누적수입의 지급이 중지됩니다. 명확히 하자면, '이용제한'된 회원과 사실상 동일한 회원으로 볼 수 있는 계정이 존재하는 경우, 연관 계정 전체에 대해 서비스 이용 제한 등 제반 조치를 취할 수 있습니다.</span>
                                </li>
                                <li>
                                    <span> 이용제한 해제는 '이용제한' 사유를 확인 또는 수정하신 후 '이용제한 해제 요청'을 하시면, 운영정책에 따라 이용제한 해제 가능 여부를 검토하여 처리합니다.</span>
                                </li>
                                <li><span> 단, 다음의 내용이 확인될 경우, 회원의 계정은 '영구정지' 상태가 되며, 전체 게시물에 대한 광고의 게재 및 누적 수입의 지급이 영구히 중지됩니다.</span>
                                </li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">회원의 계정이 '이용제한' 상태에서 탈퇴하는 경우</li>
                                <li className="pl-1">일사의 관계자임을 사칭하는 행위를 하거나 시도한 경우</li>
                                <li className="pl-1">반복적인 버그 악용 및 자동화된 프로그램을 통해 인위적으로 클릭을 발생시키는 경우</li>
                                <li className="pl-1">허가되지 않은 스팸메일 발송, 쿠키 및 IP 조작, 불법 또는 사전에 협의되지 않은 S/W 활용, 유사/오타 도메인을
                                    사용하는 행위 등
                                </li>
                                <li className="pl-1">기타 선의의 이용자와 회사에 심각한 피해를 끼치거나 끼칠 우려가 있는 경우</li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>2) 휴 &bull; 폐업 사업자에 대한 제한</span></p>
                            <p>&nbsp;</p>
                            <p><span>사업자인 회원이 휴업 또는 폐업 상태임이 확인될 경우, 광고의 게재 및 수입의 지급이 거절될 수 있습니다.</span></p>
                            <p>&nbsp;</p>
                            <ul>
                                <li>
                                    <span> 휴업 상태가 종료되면 광고 재개가 가능하며, 잔여 수입을 지급 받을 수 있습니다. '휴업'이 종료되기 전에 탈퇴신청을 하는 경우 잔여수입을 지급 받을 수 있습니다.</span>
                                </li>
                                <li><span>'폐업'의 경우, 더 이상 서비스 이용이 불가하며, 탈퇴신청 시 잔여수입을 지급받을 수 있습니다.</span></li>
                                <li><span>'휴업' 또는 '폐업' 상태에서는 회원정보변경이 불가합니다.</span></li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <ol start="5">
                                <li><span><b>수익배분</b></span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <p>
                                <span>일사 파트너스에서 발생하는 수입은 회사가 별도로 정한 수익배분 기준에 따라 회원에게 분배됩니다. 수입은 현금으로 지급함을 원칙으로 하며, 지급조건 및 지급시기는 다음과 같습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 구매상품의 수익 지급율 및 지급제외상품</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">수익 지급율은 카테고리및 상품별 특성을고려하여 회사가 정한바에 따름. 단, 별도로 정하지 않은 경우에는 결제금액의 3%로
                                    함.
                                </li>
                                <li className="pl-1">기프트카드 및유상으로제공되는제품보증서비스, 기타 회사가 사전 공지한 상품/카테고리의 경우, 수익금 지급 대상에서
                                    제외됨.
                                </li>
                                <li className="pl-1">수익 지급율 및 지급제외 상품은 회사의 사정에 따라 변경될 수 있음.</li>
                            </ul>
                            <ul>
                                <li><span> 매월 1일부터 말일까지 기간 동안 결제가 완료된 건에 대해 매출을 정산하고, 해당 매출에서 취소 및 반품분을 제외한 수입 금액을 익익월 15일에 지급합니다. 단, 15일이 한국의 주말 또는 공휴일인 경우 해당 주말 또는 공휴일이 지난 바로 다음 영업일에 지급합니다(이하 같음)&nbsp;</span>
                                </li>
                                <li>
                                    <span> 익월 25일에 일사 파트너스 사이트(리포트&gt;지급리포트)에서 산정된 수익금내역을 제공하며, 이상이 있을 경우에는 14일 이내에 확인을 요청할 수 있습니다.&nbsp;</span>
                                </li>
                                <li><span> 개인회원의 경우, 최종 수입 금액을 익익월 15일에 회원이 지정한 계좌로 지급합니다.</span></li>
                                <li><span> 사업자 회원의 경우, 최종 수입 금액에 대한 세금계산서 발행 및 승인 절차를 통해 익익월 15일에 지급합니다.</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">사업자 회원 수입 지급 절차: 당월 매출 발생 &gt; 익월 25일 최종 수입 금액 합산 &gt; 익월 26일 일사에서
                                    세금계산서
                                    역발행 &gt; 익익월 10일까지 사업자 회원 승인 &gt; 익익월 15일 승인 된 금액 지급
                                </li>
                            </ul>
                            <ul>
                                <li><span> 명절 등 장기 휴일로 인해 지급일 변동이 불가피할 경우 회원들에게 공지 후 변경될 수 있습니다.</span></li>
                                <li><span> 아래 사유에 해당될 경우에는 수입 지급이 이월될 수 있습니다.</span></li>
                            </ul>
                            <ul className="list-['-'] ml-6">
                                <li className="pl-1">세금계산서 승인 기한까지 회원이 승인을 하지 않았거나, 세금계산서 반려 후 기한 내 재승인이 이루어지지 않았을 경우.
                                </li>
                                <li className="pl-1">실제 지급 과정에서 증빙 서류 불충분, 계좌 불능 등으로 지급이 실패한 경우.</li>
                            </ul>
                            <ul>
                                <li><span> 정산 받을 수입이 10,000원 이하인 경우 다음 달로 이월하여 누적합니다.</span></li>
                                <li>
                                    <span> 별도로 정하지 않은 경우, 수입 지급의 최대 금액은 1개월 기준 3,000만원이며, 이를 초과하여 발생한 수입은 이월되거나 지급되지 않습니다.&nbsp;</span>
                                </li>
                                <li><span> 월 중 가입 또는 탈퇴로 인해 정산 일자가 1개월에 미치지 못할 경우, 일할 계산되어 적용됩니다.&nbsp;</span></li>
                            </ul>
                            <p><span> &nbsp; 예) 6월 15일에 가입한 경우, 월 최대 수입금액은 1,500만원(3,000만원 x 15/30)으로 적용됨.&nbsp;</span>
                            </p>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <ol start="6">
                                <li><span> 부당한 수입의 지급 보류ㆍ거절 및 회수</span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <p><span>회원이 일사 파트너스 약관, 운영정책 또는 관계법령 등을 위반하거나 미디어의 방문자가 약관, 운영정책 또는 관계법령에서 금지하는 행위를 하여 회원에게 발생한 수입을 '부당한 수입'으로 판단합니다.</span>
                            </p>
                            <p><span>일사 파트너스는 회사의 자체적인 점검 등을 통해 '부당한 수입'으로 의심 되는 정황이 있는 경우 확인 시까지 지급을 보류할 수 있으며 보류 후 부당한 수입이 발생한 사실이 확인된 경우 회원에 대한 수입의 지급을 거절할 수 있습니다. 또한 해당 "부당한 수입"(이미 지급된 수입 포함)을 회원으로부터 회수할 수 있습니다.</span>
                            </p>
                            <p>&nbsp;</p>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <ol start="7">
                                <li><span><b>회원탈퇴</b></span></li>
                            </ol>
                            <p>&nbsp;</p>
                            <ul>
                                <li><span> 회원은 원하는 경우 언제든 일사 파트너스 서비스의 탈퇴를 신청하실 수 있습니다. 단, 정산이 완료되지 않은 수입이 있는 경우 정산절차가 완료된 후 탈퇴 처리가 완료됩니다. 다만, 회원은 잔여 수입 및 전환 예정 금액 상당을 포기함으로써 즉시 탈퇴를 요청할 수 있으며, 회원이 잔여 수입 및 전환 예정 금액 상당을 포기하더라도 회원의 탈퇴 요청 시점에 따라 수익의 지급 여부가 변동될 수 있습니다</span>
                                </li>
                                <li><span> 아래와 같은 경우 탈퇴 처리가 진행됩니다.</span></li>
                            </ul>
                            <ul className="list-['-'] ml-8">
                                <li className="pl-1">일사 파트너스 페이지에 접속한 이력이 12개월 이상이 경과한 경우</li>
                                <li className="pl-1">일사 파트너스에서 제공한 Open API를 마지막으로 호출한 시점이 12개월 이상이 경과한 경우</li>
                                <li className="pl-1">일사 파트너스를 통해 생성한 일사으로 랜딩되는 링크에 클릭이 12개월 이상 발생되지 않는 경우</li>
                            </ul>
                            <ul>
                                <li><span> 회원이 탈퇴를 신청하면 신청 즉시 광고의 게재가 중지되며, 탈퇴신청일까지의 수입 잔액이 존재하는 경우 추후 지급합니다.</span>
                                </li>
                                <li><span> 회원의 잔여 수입은 탈퇴 신청일 익익월 15일까지 지급됩니다.</span></li>
                                <li><span>'부당한 수입'의 회수로 인해 회원의 수입 잔액이 0원 미만이 되는 경우 탈퇴 시 해당 금액을 회사에 변제해야 합니다.</span></li>
                                <li><span> 자진탈퇴를 하는 경우 탈퇴 완료(모든 수익금 처리가 완료 되는 시점)부터 언제든지 재가입이 가능합니다.</span></li>
                                <li><span> 관련법령 및 일사 이용약관 위반으로 일사 계정이 탈퇴 처리되는 경우 "일사 파트너스"도 즉시 탈퇴 처리됩니다. 이 경우, "일사 파트너스"는 자진탈퇴로 처리되며, 수입지급 및 재가입, 이용제한 기록 승계에 대한 기준은 자진탈퇴와 동일한 기준이 적용됩니다.</span>
                                </li>
                                <li><span> 일사 계정이 휴면으로 전환되거나 탈퇴하는 경우 일사 파트너스도 자동 탈퇴 처리 됩니다.</span></li>
                                <li><span> 단, 타인의 명의를 도용하여 탈퇴 처리되는 경우에는 재가입 및 서비스 이용제한 기록의 승계 기준이 적용되지 않고, 수입잔액이 지급되지 않으므로 타인의 명의를 도용하여 가입하는 일이 없도록 유의하시기 바랍니다.</span>
                                </li>
                            </ul>
                            <p><span>&nbsp;</span></p>
                            <p>&nbsp;</p>
                            <p><span>※ 본 운영정책은 2024년 9월 28일부터 적용됩니다.</span></p>
                        </div>
                    }
                    {
                        activeTab === 'privacy' && <div>
                            <br/><h2 className="text-sm font-bold">일사 개인정보 처리방침</h2>
                            <br/><br/>일사 주식회사(이하 ‘일사’)는 「개인정보 보호법」 및 「위치정보의 보호 및 이용 등에 관한 법률(이하 ‘위치정보법’)」에 따라 이용자의 개인정보
                            및 개인위치정보를 보호하고
                            이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립·공개합니다. 개인정보 처리방침을 변경하는 경우에는 변경에
                            대한 사실 및 시행일, 변경
                            전후의 내용을 홈페이지 공지사항을 통해 지속적으로 공개합니다.<br/><br/>본 개인정보 처리방침은 일사이 제공하는 서비스 중 일사(이커머스), 일사이츠,
                            일사플레이, 일사 라이브 크리에이터,
                            일사 파트너스의 서비스에 적용되며, 일사이 제공하는 그 밖의 서비스에는 적용되지 않습니다.<br/><br/>일사은 수집한 개인정보를 본래 수집한 목적 이외의 용도로
                            이용하지 않으며, 이용 목적이
                            변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다. 일사은 관계 법령에 따른 개인정보 보유 기간 및 이용자로부터
                            개인정보를 수집할 때 고지하고
                            동의받은 기간 내에서 개인정보를 처리·보유합니다. 관계 법령에 따른 개인정보의 보유 기간은 ‘4.개인정보의 파기 절차 및 방법’과 같습니다.<br/><br/>또한,
                            위치기반서비스사업과 관련하여
                            개인위치정보의 처리에 관한 사항은 본 개인정보 처리방침의 ‘8. 개인위치정보의 처리’를 통해 확인 할 수 있습니다.<br/><br/><br/><b>1. 개인정보 수집
                            항목 및 목적과 보유
                            기간</b><br/>일사는 서비스 이용에 필요한 최소한의 개인정보를 수집합니다. 이용자의 개인정보와 서비스 방문 및 검색, 서비스 이용을 통해 이용자의 관심, 흥미,
                            기호 등을 분석하여 개인
                            성향에 맞춤화된 서비스를 제공하고 이용자가 원하는 시간, 장소 및 방식에 맞게 상품을 배송하는 혁신적인 쇼핑 경험을 제공합니다.

                            <table className="min-w-full border-collapse border-t border-b border-gray-200 mt-4">
                                <thead>
                                <tr className="bg-gray-100">
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200"> 분류</th>
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200"> 목적</th>
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200"> 항목</th>
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-gray-200">보유 및 이용기간</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200"
                                        rowSpan="3">필수
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">회원 가입 및 이용자 식별,
                                        회원관리
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">아이디(이메일), 이름,
                                        휴대폰번호, 비밀번호
                                    </td>
                                    <td className="p-2 text-[12px] font-bold border-b border-gray-200" rowSpan="2">회원탈퇴
                                        시 90일 후 파기
                                    </td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">개인화 서비스 제공</td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">아이디(이메일), 이름,
                                        휴대폰번호, 서비스 이용기록, 연령
                                        및 성별*
                                    </td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">부정행위 방지</td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">부정행위 탐지된 아이디(이메일),
                                        이름, 휴대폰번호, 부정행위
                                        기록, CI
                                    </td>
                                    <td className="p-2 text-[12px] font-bold border-b border-gray-200">회원탈퇴 시 6개월 보관 후
                                        파기
                                    </td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200"
                                        rowSpan="2">선택
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">일사 아이디를 이용하는 서비스의
                                        마케팅 및 프로모션
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">아이디(이메일), 휴대폰번호
                                    </td>
                                    <td className="p-2 text-[12px] font-bold border-b border-gray-200">회원탈퇴 시 파기</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">인구통계학적 특성과 이용자의 관심
                                        및 성향의 추정을 통한
                                        맞춤형 광고에 활용
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">서비스 이용기록, 연령 및
                                        성별*
                                    </td>
                                    <td className="p-2 text-[12px] font-bold border-b border-gray-200">동의 철회 시 맞춤형 광고
                                        차단, 회원 탈퇴 시 파기
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <p className="break-keep text-right text-[10px] text-gray-400 mt-1 mb-3">'연령 및 성별'은 회원 가입
                                이후, 본인확인을 진행한 이용자에
                                한해
                                처리되는 정보입니다.</p>
                            <br/><br/>일사은 다양한 서비스 제공을 위해 이용자에게 동의를 받고 추가적인 개인정보를 수집할 수 있습니다<br/><br/><b>2.개인정보의
                            제공과 위탁</b><br/>일사은
                            이용자에게 사전 동의를 받은 범위 내에서만 개인정보를 제3자에게 제공합니다.<br/><br/>다만, 일사은 「개인정보 보호법」, 「정보통신망 이용촉진 및 정보보호
                            등에 관한 법률」,
                            「통신비밀보호법」, 「전기통신사업법」, 「전자상거래 등에서의 소비자보호에 관한 법률」, 「국세기본법」, 「신용정보의 이용 및 보호에 관한 법률」, 「소비자기본법」,
                            「자살예방 및 생명존중문화
                            조성을 위한 법률」, 「제품안전기본법」 등 다른 법률에 특별한 규정이 있는 경우에 법률에서 규정한 적법한 절차에 따라 제3자에게 이용자의 개인정보를 제공할 수
                            있습니다. 특히, 일사은 재난,
                            감염병, 급박한 생명·신체 위험을 초래하는 사건·사고, 급박한 재산 손실 등의 긴급 상황이 발생하는 경우 이용자의 동의 없이 관계기관에 개인정보를 제공할 수
                            있습니다.<br/><br/>일사은
                            원활한 서비스 제공을 위하여 개인정보 처리업무를 위탁하고 있습니다. 일사은 처리업무 위탁 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보
                            처리금지, 기술적·관리적 보호조치,
                            재위탁 제한, 수탁자에 대한 관리·감독, 손해배상책임 등에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 관리·감독하고
                            있습니다.<br/><br/><br/><b>3. 이용자의 동의없는 이용 및 제공</b><br/>일사은 이용자에게 동의받은 범위 내에서만 개인정보를 이용 및 제공합니다.
                            단, 「개인정보 보호법」
                            제15조 제3항 또는 제17조 제4항에 따라 이용자의 동의 없이 개인정보를 추가적으로 이용·제공할 수 있습니다. 이 경우, 일사은 정보주체의 동의 없는 개인정보의
                            추가적인 이용·제공을 위해 아래
                            사항을 고려하겠습니다.<br/><br/>
                            <ul className="ml-4 list-disc">
                                <li>당초 수집 목적과 관련성이 있는지 여부</li>
                                <li>개인정보를 수집한 정황 또는 처리 관행에 비추어 볼 때 개인정보의 추가적인 이용 또는 제공에 대한 예측 가능성이 있는지 여부</li>
                                <li>이용자의 이익을 부당하게 침해하는지 여부</li>
                                <li>가명처리 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부</li>
                            </ul>
                            <br/>만약 개인정보의 추가적인 이용∙제공이 지속적으로 발생하는 경우에는 위 사항에 대한 판단기준을 공개하고, 해당 기준의 준수 여부를
                            점검하겠습니다.<br/><br/><br/><br/><b>4. 개인정보의 파기 절차 및 방법</b><br/>일사은 개인정보
                            보유기간의 경과, 처리목적
                            달성 등 개인정보가 불필요하게 되었을 때에는 해당 개인정보를 파기합니다. 단, 「개인정보 보호법」 제 15조 제1항 제6호에 따른 내부방침에 따라 부정 행위
                            제재기록을 별도로 분리하여 5년간
                            보관 후 파기합니다.<br/><br/>개인정보의 파기 절차 및 방법은 다음과 같습니다.<br/>
                            <ul className="ml-4 list-disc">
                                <li>파기 절차 : 개인정보 목적 달성 후 내부 방침 및 관련 법령에 의한 의무에 따라 일정기간 동안 별도로 분리하여 저장 후 파기합니다.</li>
                                <li>파기 방법 : 전자적 파일 형태로 저장된 개인정보는 기록을 복원이 불가능한 방법으로 영구 파기하며, 종이문서에 저장된 개인정보는 분쇄기로 분쇄하거나
                                    소각 등을 통하여
                                    파기합니다.
                                </li>
                            </ul>
                            <br/>이용자로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당
                            개인정보를 별도로 분리하여
                            저장·관리합니다.

                            <table className="min-w-full border-collapse border-t border-b border-gray-200 mt-4">
                                <thead>
                                <tr className="bg-gray-100">
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200">보유정보</th>
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-r border-gray-200">보유기간</th>
                                    <th className="px-2 py-3 text-center text-[12px] font-bold border-b border-gray-200">근거법령</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">대금결제 및
                                        재화 공급에 관한 기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">5년</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200" rowSpan="4">「전자상거래 등에서의
                                        소비자보호에 관한 법률」
                                    </td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">계약 또는
                                        청약철회 등에 관한 기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">5년</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">소비자의 불만
                                        또는 분쟁처리에 관한 기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">3년</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">표시/광고에
                                        관한 기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">6개월</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">전자금융 거래에
                                        관한 기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">5년</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200">「전자금융거래법」</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">개인위치정보주체에
                                        대한 위치정보
                                        수집·이용·제공사실 확인자료
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">6개월</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200">「위치정보의 보호 및 이용 등에 관한 법률」
                                    </td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">웹사이트, 앱
                                        방문 기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">3개월</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200">「통신비밀보호법」</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">제세공과금
                                        대납을 위한 정보
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">5년</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200">「소득세법」</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">신용 정보의
                                        수집 처리 및 이용 등에 관한
                                        기록
                                    </td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">3년</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200">「신용정보의 이용 및 보호에 관한 법률</td>
                                </tr>
                                <tr>
                                    <td className="p-2 text-[12px] font-bold border-b border-r border-gray-200">개인신용정보</td>
                                    <td className="p-2 text-[12px] border-b border-r border-gray-200">5년</td>
                                    <td className="p-2 text-[12px] border-b border-gray-200">「신용정보의 이용 및 보호에 관한 법률</td>
                                </tr>
                                </tbody>
                            </table>


                            <br/><br/><br/><br/><b>5. 이용자와 법정대리인의 권리·의무 및 그 방법</b><br/>이용자의 개인정보는
                            아래와 같은 방법을 통해 열람,
                            정정, 삭제, 동의 철회, 처리정지 요청을 할 수 있습니다. 서비스를 통해 직접 확인하지 못하는 정보는 ‘9. 개인정보보호책임자와 민원처리부서’의 민원처리부서에게
                            요청하여 확인할 수 있습니다.
                            이용자의 요청에 대한 진행경과(처리결과)는 요청을 받은일로부터 10일이내에 회신합니다. 법정대리인이나 위임을 받은 대리인은 위임장, 가족관계증명서 등을 제출하여
                            정당한 대리인 여부를 입증해야
                            합니다.<br/><br/>다만, 아래의 경우에는 동의 철회, 삭제, 처리 정지가 어려울 수 있습니다.<br/>
                            <ul className="ml-4 list-disc">
                                <li>법령에 특별한 규정이 있거나 법령상 의무를 다하기 위해 불가피한 경우</li>
                                <li>다른 사람의 신체, 생명을 해할 우려가 있거나 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우</li>
                                <li>개인정보를 처리하지 않으면서 이용자와 약정한 서비스를 제공하지 못하는 경우로서 이용자가 그 계약의 해지 의사를 명확하게 밝히지 않은 경우</li>
                            </ul>
                            <br/>아이디 및 비밀번호는 타인에게 양도하거나 대여할 수 없으며 이로 인해 발생한 문제에 대해서는 일사이 책임지지 않습니다. 타인의 정보 및 존엄성을 훼손할
                            시에는「개인정보
                            보호법」,「정보통신망법」등에 의해 처벌받을 수 있습니다.<br/><br/><br/>5.1 행태정보의 수집·이용·제공 및 거부 등에 관한 사항<br/>일사은 이용자를
                            더 잘 이해하여 무의미하고
                            불필요한 광고 노출을 지양하고, 이용자의 관심 상품 등을 반영한 정보성 광고의 노출을 증가시키기 위하여 온라인상의 이용자 활동 정보를 활용합니다. 단, 인종, 종교,
                            성적 지향, 병력 정보와
                            같은 민감 카테고리로 분류된 행태정보는 맞춤형 광고에 활용하지 않습니다.<br/><br/>온라인 행태정보 기반의 맞춤형 광고는 ‘쿠키(Cookie)’ 또는
                            ‘광고식별자(ADID/IDFA)’를
                            기반으로 웹 사이트 방문 이력, 앱 사용 이력, 구매 및 검색 이력 등 이용자의 관심, 흥미, 기호 및 성향 등(이하, 행태정보)을 파악하고 분석할 수 있는
                            행태정보를 활용하여 맞춤형 광고를
                            제공합니다.<br/><br/>일사은 ‘온라인 맞춤형 광고 개인정보보호 가이드 라인’에 따른 이용자 권리보장을 위해 일사 맞춤형 광고의 내용을 안내하고
                            있습니다.<br/>일사 맞춤형
                            광고 <br/><br/><br/>5.2 개인정보를 자동으로 수집하는 장치의 설치·운영 및 그 거부에 관한 사항<br/>일사은 이용자에게 개별적인 맞춤화된 서비스를
                            제공하기 위해 이용 정보를
                            저장하고 수시로 불러오는 ‘쿠키(Cookie)’를 사용합니다. 이용자가 웹사이트에 접속할 경우 웹 사이트 서버는 이용자의 디바이스에 저장되어 있는 쿠키의 내용을 읽어
                            이용자의 환경설정을 유지하고
                            맞춤화된 서비스를 제공하게 됩니다.<br/><br/>쿠키의 사용목적<br/>쿠키는 이용자가 웹 사이트를 방문할 때, 웹 사이트 사용을 설정한대로 접속하고 편리하게
                            사용할 수 있도록 합니다.
                            또한, 이용자의 웹사이트 방문 기록, 이용 형태를 통해서 최적화된 광고 등 맞춤형 정보를 제공하기 위해 활용됩니다.<br/><br/>쿠키 수집 거부<br/>이용자는
                            쿠키 설치에 대한 선택권을
                            가지고 있습니다. 따라서, 이용자는 웹 브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할
                            수도 있습니다. 다만, 쿠키
                            설치를 거부할 경우 웹 사용이 불편해지며, 로그인이 필요한 일부 서비스 이용에 어려움이 있을 수 있습니다.<br/><br/><br/><br/><b>6.
                            개인정보의 안전성 확보조치</b><br/>일사은
                            이용자의 개인정보를 처리함에 있어 개인정보가 도난, 유출, 변조, 또는 훼손되지 않도록 기술적 관리적 보호조치를 강구하고 있습니다.<br/>
                            <ul className="ml-4 list-disc">
                                <li>기술적 보호조치: 해킹시도 및 유출에 대한 실시간 모니터링 및 차단, 접근통제 적용, 접속기록의 보관 및 위변조 방지 적용, 비밀번호 및 개인정보
                                    암호화 저장, 전송 시 암호화
                                </li>
                                <li>관리적 보호조치: 개인정보보호 전담조직 운영, 개인정보취급자 대한 정기적인 교육 수행, 직원을 대상으로 한 인식제고 활동, 규정 준수상태 정기적
                                    점검
                                </li>
                                <li>물리적 보호조치: 외부로부터 접근이 통제된 구역에 시스템 설치 및 운영, 안전한 출입통제 절차 수립 및 운영</li>
                            </ul>
                            <br/><br/><br/><b>7. 개인위치정보의 처리</b><br/>일사는 위치정보법에 따라 이용자의 개인위치정보를 안전하게 관리합니다.<br/><br/>개인위치정보의
                            처리목적 및
                            보유기간<br/>일사이츠 서비스의 ‘위치기반서비스 이용약관 제8조’에 따라 위치기반 서비스 제공을 위해 필요한 경우 이용목적 달성을 위해 필요한 최소한의 기간동안
                            개인 위치정보를 보유할 수
                            있습니다.<br/><br/>위치기반 서비스의 내용 : 이용자 위치기반 배달음식업소 제공 서비스, 이용자위치기반 주소 찾기 제공 서비스<br/><br/>이용자가 작성한
                            게시물 또는 콘텐츠와 함께
                            위치정보가 저장되는 서비스의 경우 해당 게시물 또는 콘텐츠의 보관기간 동안 개인위치정보가 보관될 수 있습니다.<br/><br/>개인위치정보와 개인위치정보의
                            수집·이용·제공사실 확인자료의
                            파기<br/>이용자의 개인위치정보는 수집 및 이용 목적의 달성 또는 회원 탈퇴 등 개인위치정보 처리목적이 달성된 경우, 복구 및 재생되지 않도록 안전하게 파기합니다.
                            다른 법령에 따라 보관해야
                            하는 등 정당한 사유가 있는 경우에는 그에 따릅니다. 이용자의 개인위치정보의 수집이용·제공사실 확인자료는 위치정보법 제16조2항에 따라 위치정보시스템에 6개월간
                            보관합니다.<br/><br/>개인위치정보의
                            제3자제공 및 통지<br/>
                            <ul className="ml-4 list-disc">
                                <li>일사은 이용자의 동의 없이 개인위치정보를 제3자에게 제공하지 않으며, 제3자에게 제공하는 경우에는 제공받는 자 및 제공목적을 사전에 이용자에게 고지하고
                                    동의를 받습니다.
                                </li>
                                <li>이용자의 동의를 거쳐 개인위치정보를 제3자에게 제공하는 경우, 매회 이용자에게 제공받는 자, 제공일시 및 제공목적을 통지합니다.</li>
                            </ul>
                            <br/><br/>8세 이하의 아동 등의 보호의무자 권리 및 의무와 그 행사방법<br/>위치정보법 제26조제1항에 따라 아래 이용자의 생명 또는 신체보호를 위하여
                            보호의무자가 개인위치정보의 이용
                            또는 제공에 동의하는 경우에는 본인의 동의가 있는 것으로 봅니다.<br/><br/>권리를 행사하고자 하는 보호의무자는 서면 동의서에 보호의무자임을 증명하는 서면 또는
                            가족관계 증빙 등을 첨부하여
                            회사에 제출하여야 하며, 이 경우 보호의무자는 위치기반서비스 이용약관에 따른 이용자의 권리를 모두 가집니다.<br/>
                            <ul className="ml-4 list-disc">
                                <li>8세 이하의 아동</li>
                                <li>피성년 후견인</li>
                                <li>장애인복지법 제2조제2항제2호에 따른 정신적 장애를 가진 사람으로서 장애인고용촉진 및 직업재활법 제2조제2호에 따른 중증장애인에 해당하는
                                    사람(장애인복지법 제32조에 따라 장애인
                                    등록을 한 사람에 한정)
                                </li>
                            </ul>
                            <br/><br/>위치정보관리책임자는 ‘8.개인정보보호책임자와 민원처리 부서’의 개인정보보호책임자(CPO)가 겸직하고 있습니다. 그 외 개인위치정보 처리와 관련된
                            자세한 내용은 ‘일사이츠 서비스
                            – 위치기반서비스 이용약관’을 참고하시기 바랍니다.<br/><br/><br/><br/><b>8. 개인정보보호책임자와 민원처리 부서</b><br/>일사은
                            개인정보 처리에 관한
                            업무를 총괄하여 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.<br/>
                            <ul className="ml-4 list-disc">
                                <li>민원처리 담당부서 : 1566-1013</li>
                                <li>이메일 : customer@ilsaram.co.kr</li>
                                <li>개인정보분쟁조정위원회 : (국번없이) 1833-6972 (www.kopico.go.kr)</li>
                                <li>개인정보침해신고센터 : (국번없이) 118 (privacy.kisa.or.kr)</li>
                                <li>대검찰청 : (국번없이) 1301 (www.spo.go.kr)</li>
                                <li>경찰청 : (국번없이) 182 (ecrm.cyber.go.kr)</li>
                            </ul>
                            <br/><br/><br/>개인정보처리방침 시행일자: 2024. 9. 28<br/>
                        </div>
                    }


                </div>
            </div>
        </main>
    );
};

export default Policy;
